const googleTestimonialsInit = async () => {
    const testimonialBlocks = Array.from(document.querySelectorAll('.bn-google-testimonials'));

    if (!testimonialBlocks.length || !window.google?.maps) {
        return;
    }

    let Place;

    try {
        ({ Place } = await google.maps.importLibrary('places'));
    } catch {
        return;
    }

    const createStars = (rating) => {
        const stars = document.createElement('span');
        stars.className = 'bn-google-testimonials__stars';
        stars.setAttribute('aria-label', `${rating} out of 5 stars`);
        stars.textContent = String.fromCharCode(9733).repeat(5);

        return stars;
    };

    const createAuthor = (review) => {
        const author = document.createElement('div');
        const authorName = document.createElement('strong');
        const attribution = review.authorAttribution || {};

        author.className = 'bn-google-testimonials__author';
        authorName.className = 'bn-google-testimonials__author-name';
        authorName.textContent = attribution.displayName || 'Google user';

        if (attribution.photoURI) {
            const photo = document.createElement('img');

            photo.className = 'bn-google-testimonials__author-photo';
            photo.src = attribution.photoURI;
            photo.alt = '';
            author.appendChild(photo);
        } else {
            const fallback = document.createElement('span');

            fallback.className = 'bn-google-testimonials__author-fallback';
            fallback.setAttribute('aria-hidden', 'true');
            fallback.textContent = authorName.textContent.charAt(0).toUpperCase();
            author.appendChild(fallback);
        }

        author.appendChild(authorName);

        return author;
    };

    const createTestimonial = (review, placeUrl) => {
        const item = document.createElement('article');
        const text = document.createElement('p');
        const reviewText = review.text || '';
        const maxLength = 220;

        item.className = 'bn-google-testimonials__item';
        item.setAttribute('role', 'listitem');
        item.appendChild(createStars(review.rating || 0));

        text.className = 'bn-google-testimonials__text';
        text.textContent = reviewText.length > maxLength ? `${reviewText.slice(0, maxLength).trim()}... ` : reviewText;
        item.appendChild(text);

        if (reviewText.length > maxLength && placeUrl) {
            const readMore = document.createElement('a');

            readMore.className = 'bn-google-testimonials__read-more';
            readMore.href = placeUrl;
            readMore.target = '_blank';
            readMore.rel = 'noopener noreferrer';
            readMore.textContent = 'Learn more';
            text.appendChild(readMore);
        }

        item.appendChild(createAuthor(review));

        return item;
    };

    testimonialBlocks.forEach(async (testimonialBlock) => {
        const placeId = testimonialBlock.dataset.placeId;

        if (!placeId) {
            return;
        }

        try {
            const place = new Place({ id: placeId });

            await place.fetchFields({
                fields: ['googleMapsURI', 'reviews'],
            });

            const reviews = (place.reviews || [])
                .filter((review) => review.text && review.rating)
                .sort((firstReview, secondReview) => {
                    const ratingDifference = secondReview.rating - firstReview.rating;

                    if (ratingDifference) {
                        return ratingDifference;
                    }

                    return new Date(secondReview.publishTime || 0) - new Date(firstReview.publishTime || 0);
                })
                .slice(0, 3);

            if (!reviews.length) {
                return;
            }

            const grid = testimonialBlock.querySelector('.bn-google-testimonials__grid');

            reviews.forEach((review) => {
                grid.appendChild(createTestimonial(review, place.googleMapsURI));
            });

            grid.hidden = false;
        } catch {
            return;
        }
    });
};

document.addEventListener('DOMContentLoaded', googleTestimonialsInit);